module.exports = __webpack_public_path__ + "img/call_center.fc36e6ea.jpg";